import React from 'react';

const MainHeader = (props) => <header>{props.children}</header>;

export default MainHeader;
